var $6f40c3a58f594b58$exports = {};
window.scrollTo(0, 0);
const $6f40c3a58f594b58$var$sidebarEl = document.getElementById('sidebar-wrapper');
const $6f40c3a58f594b58$var$openBtnEl = document.getElementById('menu-open-link');
const $6f40c3a58f594b58$var$closeBtnEl = document.getElementById('menu-close-link');
const $6f40c3a58f594b58$var$scrollTo = (selector)=>{
    document.querySelector(selector).scrollIntoView({
        behavior: 'smooth'
    });
};
const $6f40c3a58f594b58$var$toggleMenu = ()=>{
    $6f40c3a58f594b58$var$sidebarEl.classList.toggle('active');
};
const $6f40c3a58f594b58$var$isMenuOpen = ()=>$6f40c3a58f594b58$var$sidebarEl.classList.contains('active');
const $6f40c3a58f594b58$var$handleClick = (event)=>{
    const isOpenBtnClick = $6f40c3a58f594b58$var$openBtnEl.contains(event.target);
    const isCloseBtnClick = $6f40c3a58f594b58$var$closeBtnEl.contains(event.target);
    // Open and close side menu
    if (isOpenBtnClick || isCloseBtnClick) {
        event.preventDefault();
        $6f40c3a58f594b58$var$toggleMenu();
        return;
    }
    const isSidebarClick = $6f40c3a58f594b58$var$sidebarEl.contains(event.target);
    // Close side-menu on outside click when open
    if (!isSidebarClick && !isOpenBtnClick && $6f40c3a58f594b58$var$isMenuOpen()) {
        $6f40c3a58f594b58$var$toggleMenu();
        return;
    }
    let targetId = null;
    let currentNode = event.target;
    while(currentNode && currentNode.getAttribute){
        targetId = currentNode.getAttribute('data-target');
        if (targetId) break;
        currentNode = currentNode.parentNode;
    }
    if (targetId) {
        event.preventDefault();
        $6f40c3a58f594b58$var$scrollTo(`#${targetId}`);
        if ($6f40c3a58f594b58$var$isMenuOpen()) $6f40c3a58f594b58$var$toggleMenu();
    }
};
document.addEventListener('click', $6f40c3a58f594b58$var$handleClick);


//# sourceMappingURL=repo.94f51855.js.map
